import type { QuestionAssignmentAnswer } from 'domain/question';
import type { PerspectiveApi } from 'store/apis/event/types';

// The room's list holds every topic that ran in it and, until the backend filters it, every participant's
// perspectives; the store holds the caller's own on one topic.
export const mapRoomPerspectivesFromApi = (
  perspectives: PerspectiveApi[],
  topicId: number,
  authorId: number
): QuestionAssignmentAnswer[] =>
  perspectives
    .filter((perspective) => perspective.topicId === topicId && perspective.authorIds.includes(authorId))
    .map(({ perspectiveId, text, authorIds, isAnonymous }) => ({
      type: 'TextAnswer',
      uuid: perspectiveId,
      assignedToUserIds: authorIds,
      text,
      isAnonymous,
    }));
